import axios from "axios";

const _SERVICES_RHOMTRIP = process.env.VUE_APP_SERVICES_RHOMTRIP;
const _IMAGE_URL = process.env.VUE_APP_IMAGE_URL;

const _API = `${_SERVICES_RHOMTRIP}/api/v1.0`;
const _PUB = `${_SERVICES_RHOMTRIP}/api/public`;

export default {
  _API: _API,
  _PUB: _PUB,
  _IMAGE_URL: _IMAGE_URL,
  axios: token => {
    return axios.create({
      baseURL: `${_API}`,
      headers: { Authorization: `${token}` }
    });
  }
};
